module.exports = __webpack_public_path__ + "static/media/sidebar-2.3f8e951d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-2.jpg
// module id = 245
// module chunks = 0